
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.215 13h-4.41l-.869 1.724H3.83L4.691 13H3.5A1.5 1.5 0 012 11.5V5a3 3 0 013-3h6a3 3 0 013 3v6.5a1.5 1.5 0 01-1.5 1.5h-1.17l.862 1.724h-1.108L10.215 13zM5 4a1 1 0 00-1 1v2.5a1 1 0 001 1h1.5a1 1 0 001-1V5a1 1 0 00-1-1H5zm4.5 0a1 1 0 00-1 1v2.5a1 1 0 001 1H11a1 1 0 001-1V5a1 1 0 00-1-1H9.5zm-4.75 7.5a.75.75 0 100-1.5.75.75 0 000 1.5zm6.5 0a.75.75 0 100-1.5.75.75 0 000 1.5z"}})])
          )
        }
      }
    